import React from 'react';
import styled, { keyframes } from 'styled-components';
import { MEDIA } from '@constants';
import { StripBannerData, StripBannerItem, PageSlice } from '@contracts';
import StripBannerItems from './StripBannerItems';

interface StripBannerProps {
  slice: PageSlice;
}

const StripBanner: React.FC<StripBannerProps> = ({ slice }) => {
  const sliceDetails = slice.primary as StripBannerData;
  const sliceItems = slice.items as StripBannerItem[];

  return (
    <Container $backgroundColor={sliceDetails.background_color} $backgroundGradient={sliceDetails.background_gradient?.text || ''}>
      <Scroller>
        <ScrollContent>
          <StripBannerItems items={sliceItems} />
        </ScrollContent>
        <ScrollContent aria-hidden>
          <StripBannerItems items={sliceItems} />
        </ScrollContent>
      </Scroller>
    </Container>
  );
};

export default StripBanner;

const scroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

interface ContainerProps {
  $backgroundColor?: string;
  $backgroundGradient?: string;
}

const Container = styled.div<ContainerProps>`
  background-color: ${(props) => props.$backgroundColor};
  background-image: ${(props) => props.$backgroundGradient};
  position: relative;
  overflow: hidden;
  width: 100%;
`;

const Scroller = styled.div`
  display: flex;
  position: relative;
  width: max-content;
  animation: ${scroll} 30s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const ScrollContent = styled.div`
  display: flex;
  padding: 32px 36px;
  justify-content: flex-start;

  ${MEDIA.tablet} {
    padding: 20px 8px;
  }
`;
